import { Snackbar, Alert, Button } from '@mui/material';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ProfileSnackbar = ({ open, onClose }: Props) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/client/profile');
  };

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      autoHideDuration={null}
    >
      <Alert
        severity="warning"
        onClose={onClose}
        action={
          <Button
            color="primary"
            size="small"
            onClick={handleRedirect}
            sx={{ color: '#fc0841' }}
          >
            <Trans i18nKey="create_ad.complete_profile_snackbar_link" />
          </Button>
        }
      >
        <Trans i18nKey="create_ad.profile_incomplete_snackbar_alert" />
      </Alert>
    </Snackbar>
  );
};
